import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DispatchContext from '../DispatchContext';
import Register from './Register';

function Login() {
    console.log("[LOGIN] Login render");
    useEffect(() => {
        console.log("[LOGIN] MOUNT");
        return () => console.log("[LOGIN] UNMOUNT");
    }, []);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const dispatch = useContext(DispatchContext);
    const navigate = useNavigate();
    return (
        <form>Test 3</form>
    );
}

export default Login;